<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">
          新增盘点单
        </el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" @click="handleDetail(row)">详情</el-button>
      </template>
      <template slot="sheetStatus" slot-scope="{ row }">
        <el-tag v-if="row.sheetStatus === 0" size="mini">草稿</el-tag>
        <el-tag v-else-if="row.sheetStatus === 1" size="mini" type="success">已提交</el-tag>
        <el-tag v-else-if="row.sheetStatus === 2" size="mini" type="warning">已回写库存</el-tag>
        <span v-else>-</span>
      </template>
    </avue-crud>

    <!-- 新增盘点单弹窗组件 -->
    <StockTakeDialog ref="createDialog" @success="refreshChange" />
    <!-- 详情弹窗组件 -->
    <StockTakeDetailDialog ref="detailDialog" />
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getSheetPage } from './api'
import { fetchStockShedDicData } from './location-dict'
import StockTakeDialog from './components/StockTakeDialog.vue'
import StockTakeDetailDialog from './components/stock-take-detail-dialog.vue'

export default {
  name: 'StockTakeManagement',
  mixins: [crudMixins],
  components: {
    StockTakeDialog,
    StockTakeDetailDialog
  },
  data() {
    return {
      apiConfig: {
        getList: (params) => getSheetPage({ ...params })
      },
      option: {
        ...this.$store.state.publicOption,
        menuWidth: 120,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        column: [
          {
            label: '盘点单编号',
            prop: 'sheetNo',
            search: true,
            overHidden: true
          },
          {
            label: '盘点煤棚',
            prop: 'stockCode',
            type: 'select',
            search: true,
            clearable: true,
            filterable: true,
            dicData: [],
            overHidden: true,
            formatter: (row) => row.stockName || row.stockCode || '-'
          },
          {
            label: '盘点人',
            prop: 'counterName',
            search: true,
            overHidden: true
          },
          {
            label: '盘点时间',
            prop: 'countTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true
          },
          {
            label: '账面合计(吨)',
            prop: 'totalBookWeight'
          },
          {
            label: '实盘合计(吨)',
            prop: 'totalActualWeight'
          },
          {
            label: '差异(吨)',
            prop: 'totalDiffWeight'
          },
          {
            label: '差异率(%)',
            prop: 'totalDiffRate'
          },
          {
            label: '状态',
            prop: 'sheetStatus',
            slot: true,
            search: true,
            type: 'select',
            dicData: [
              { label: '草稿', value: 0 },
              { label: '已提交', value: 1 },
              { label: '已回写库存', value: 2 }
            ]
          }
        ]
      }
    }
  },
  mounted() {
    this.loadStockShedSearchDic()
  },
  methods: {
    async loadStockShedSearchDic() {
      try {
        const dic = await fetchStockShedDicData()
        const col = this.option.column.find((c) => c.prop === 'stockCode')
        if (col) this.$set(col, 'dicData', dic)
      } catch (e) {
        // ignore
      }
    },
    handleCreate() {
      this.$refs.createDialog && this.$refs.createDialog.open()
    },
    handleDetail(row) {
      this.$refs.detailDialog && this.$refs.detailDialog.open(row.id)
    }
  }
}
</script>

